import React from 'react';
import { Box, Typography } from '@mui/material';
import { useCommonStyles } from '../styles/commonStyles';

const PageHeader = ({
    title,
    subtitle,
    variant = 'gradient', // 'gradient' or 'simple'
    children // For additional components like search or buttons
}) => {
    const commonStyles = useCommonStyles();

    const headerClass =
        variant === 'gradient' ? commonStyles.headerSectionGradient : commonStyles.headerSection;

    const titleClass =
        variant === 'gradient' ? commonStyles.pageTitleWhite : commonStyles.pageTitle;

    return (
        <Box className={headerClass}>
            <Box>
                <Typography variant='h4' className={titleClass}>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography className={commonStyles.pageSubtitle}>{subtitle}</Typography>
                )}
            </Box>
            {children && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>{children}</Box>
            )}
        </Box>
    );
};

export default PageHeader;
